import {IValidateBase} from "./IValidateBase";
import {Component} from "react";
import {IValidationResult} from "./IValidationResult";

export class AP_Validation_Url extends Component implements IValidateBase {

    validateCode = "AP_Validation_Url";
    validateName = "AP_Validation_Url";

    Validate =  (prmElement:any)=> {
        let outObj:IValidationResult = {
            isError: false,
            errorMessage: "", //prmElement.ExtendedParamsObj.Validations.AP_Validation_Required.ErrorMessage || this.DefaultValues.ErrorMessage,
            ElementGuid: prmElement.ElementGuid,
        }

        if (!!prmElement
            && !!prmElement.ExtendedParamsObj
            && !!prmElement.ExtendedParamsObj.Validations
            && !!prmElement.ExtendedParamsObj.Validations.AP_Validation_Url
            && prmElement.ExtendedParamsObj.Validations.AP_Validation_Url.IsEnabled) {

            // var elementValue = applyoo.getDataItem(prmElement.DataBindStr,{});
            // var regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/
            //
            // if (elementValue && !regex.test(elementValue)) {
            //     outObj.isError = true;
            // }
        }

        return outObj;
    }

    ValidateValue =  (prmValue:any, prmParamsObj?:any)=> {
        let outObj:IValidationResult = {
            isError: false,
            errorMessage: '',
            ElementGuid: '',
        }

        if (!!prmValue){
            let regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/

            if (prmValue && !regex.test(prmValue)) {
                outObj.isError = true;
            }
        }

        return outObj;
    }
}